import * as EmailValidator from 'email-validator';
import validate from 'validate.js';
import * as messages from './messages/validations';

const emailValidator = (value: string) => {
  const isValidEmail = EmailValidator.validate(value);
  if (!isValidEmail) {
    return messages.ONLY_MAIL;
  }
  return null;
};

validate.validators.customEmailValidator = emailValidator;

export const emailValidatorBase = {
  customEmailValidator: {},
};

export const USER_NAME_MAX_LENGTH = 32;
export const USER_EMAIL_MAX_LENGTH = 64;

export const userSchemaBase = {
  first_name: {
    presence: { allowEmpty: true },
    length: {
      maximum: USER_NAME_MAX_LENGTH,
    },
  },
  last_name: {
    presence: { allowEmpty: true },
    length: {
      maximum: USER_NAME_MAX_LENGTH,
    },
  },
  email: {
    presence: { allowEmpty: false, message: messages.IS_REQUIRED },
    email: true,
    length: {
      maximum: USER_EMAIL_MAX_LENGTH,
    },
    ...emailValidatorBase,
  },
};
